import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const isLight = ref(localStorage.getItem('theme') === 'light')

  const toggleTheme = () => {
    isLight.value = !isLight.value
    localStorage.setItem('theme', isLight.value ? 'light' : 'dark')
    updateThemeClass()
  }

  const setTheme = (theme) => {
    isLight.value = theme === 'light'
    localStorage.setItem('theme', theme)
    updateThemeClass()
  }

  const updateThemeClass = () => {
    try {
      if (isLight.value) {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
        document.body.classList.remove('tema_escura')
        document.body.classList.add('tema_clara')
      } else {
        document.documentElement.classList.remove('light')
        document.documentElement.classList.add('dark')
        document.body.classList.remove('tema_clara')
        document.body.classList.add('tema_escura')
      }
    } catch (error) {
      console.error('Erro ao atualizar tema:', error)
    }
  }

  // Inicializar tema
  try {
    updateThemeClass()
  } catch (error) {
    console.error('Erro ao inicializar tema:', error)
  }

  return {
    isLight: computed(() => isLight.value),
    toggleTheme,
    setTheme
  }
})
